'use strict';

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./production/index.react-client.js');
} else {
  module.exports = require('./development/index.react-client.js');
}
